/// <reference path="../app.js"/>
/// <reference path="../../node_modules/@types/google-maps/index.d.ts"/>
/// <reference path="./markerclusterer.js"/>
/// <reference path="./ultra-light.map-style.js"/>

/**
 * The loaded pin properties
 * @typedef Distributor
 * @property {string} address
 * @property {string} title
 * @property {number} lat
 * @property {number} lng
 * @property {string} img
 * @property {"distributor" | "producer" | "cobb"} category
 * @property {string} tel
 * @property {string} district
 * @property {string} email
 * @property {string} website
 * @property {string} fax
 * @property {string} about
 * @property {string} year
 * @property {string} img
 */

const MapsAPIKey = "AIzaSyApUSiddfk5SFAzatjDy6I8BUNBUm7Ue68";
const DistributorMap = {
	/** @type {google.maps.Map} */
	map: null,
	/** @type {google.maps.Marker[]} */
	markers: [],
	markerIntervalID: null,

	init() {
		$(document.body).append($("<script src=\"https://maps.googleapis.com/maps/api/js?key=" + MapsAPIKey + "&callback=DistributorMap.onload\"></script"));
	},

	setupMarkerControls() {
		this.markerIntervalID = setInterval(() => {
			if ($(".gm-style").length == 0) return;
			clearInterval(this.markerIntervalID);

			/**
			 * Loops through an elements children and tags them by their depth
			 * @param {HTMLElement} element
			 * @param {string} name
			 * @param {number} depth
			 */
			const tagChildren = (element, name, depth) => {
				$(element).children().each((index, _element) => {
					let self = $(_element);
					self.addClass(name + "-" + depth);
					self.addClass("index-" + index);
					if (self.children().length > 0) {
						tagChildren(_element, name, depth + 1);
					}
				});
			}

			$(".gm-style").children().each((index, element) => {
				tagChildren(element, "map-element", 0);
			});

			$(".map-element-2.index-2").on("DOMSubtreeModified", function() {
				$(this).children().each((index, element) => {
					let marker = $(element);
					marker.addClass(marker.text().length ? "marker-cluster" : "marker");
					marker.addClass(marker.attr("title"));
				});
			});
		}, 100);
	},

	/**
	 * Assures that a url is properly formatted to http:// or https://
	 * @param {string} url
	 * @returns {string}
	 */
	formatURL(url) {
		if (url.startsWith("http://") || url.startsWith("https://")) return url;
		return "http://" + url;
	},

	/**
	 * Turns the loaded pins into google maps markers
	 * @param {Distributor[]} pins
	 */
	applyMarkers(pins) {
		let infoBubble = new google.maps.InfoWindow();

		for (let pin of pins) {
			let marker = new google.maps.Marker({
				position: new google.maps.LatLng(pin.lat, pin.lng),
				map: this.map,
				icon: "about:blank",
				title: pin.category,
			});

			google.maps.event.addListener(marker, 'click', () => {
				let content = "<div class=\"maps-info-window\">";

				content += "<img class=\"img\" src=\"" + pin.img + "\"/>";
				content += "<div class=\"title\">" + pin.title + "</div>";
				content += "<div class=\"address\">" + pin.address + "</div>";

				content += "<div class=\"grid-x\">";

				// Labels
				content += "<div class=\"cell shrink\">"
				if (pin.tel.length) content += "<div class=\"i-label\">Phone</div>";
				if (pin.website.length) content += "<div class=\"i-label\">Web</div>";
				if (pin.email.length) content += "<div class=\"i-label\">Email</div>";
				if (pin.fax.length) content += "<div class=\"i-label\">Fax</div>";
				if (pin.year.length) content += "<div class=\"i-label\">Year</div>";

				content += "</div>";

				// Info
				content += "<div class=\"cell auto\">"

				if (pin.tel.length) content += "<div class=\"i-content\">" + pin.tel + "</div>";
				if (pin.website.length) content += "<div class=\"i-content\"><a href=\"" + this.formatURL(pin.website) + "\">" + pin.website + "</a></div>";
				if (pin.email.length) content += "<div class=\"i-content\"><a href=\"mailto:" + pin.email + "\">" + pin.email + "</a></div>";
				if (pin.fax.length) content += "<div class=\"i-content\">" + pin.fax + "</div>";
				if (pin.year.length) content += "<div class=\"i-content\">" + pin.year + "</div>";

				content += "</div>";

				content += "</div>";

				content += "</div>";

				infoBubble.setContent(content);
				infoBubble.open(this.map, marker);
			});

			this.markers.push(marker);
		}

		new MarkerClusterer(this.map, this.markers, {
			gridSize: 26,
			maxZoom: 10,
			title: "cluster",
			minimumClusterSize: 2
		});

		this.setupMarkerControls();
	},

	onload() {
		this.map = new google.maps.Map(document.getElementById("map-canvas"), {
			center: new google.maps.LatLng(30, 21.28),
			zoom: 2,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			scrollwheel: false,
			draggable: true,
			minZoom: 2,
			streetViewControl: false,
			styles: MapStyle_UltraLight,
			gestureHandling: "cooperative"
		});
		/**
		 * @todo Link to live data source
		 */
		$.getJSON("/test_data.json").done((data) => this.applyMarkers(data));
	},
};
